module.exports = __webpack_public_path__ + "img/Group 27154.4d96ad42.svg";